import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Base from '../views/Base.vue'
import AdMaterial from '../views/AdMaterial.vue'
import Landingpage from '../views/Landingpage.vue'
import AdIdeas from '../views/AdIdeas.vue'
import AdIdeasDetail from '../views/AdIdeasDetail.vue'
import Admaster from '../views/Admaster.vue'
import AdmasterDetail from '../views/AdmasterDetail.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import AdMaterialDetail from '../views/AdMaterialDetail.vue'
import Industry from '../views/Industry.vue'
import Auth from '../views/Auth.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SearchResult from '../views/SearchResult.vue'
import IpBase from '../views/ip/Base.vue'
import IpHome from '../views/ip/Home.vue'
import IpDoc from '../views/ip/Doc.vue'
import User from '../views/User.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/ip',
    component: IpBase,
    children: [
      {
        path: '',
        name: "IpHome",
        component: IpHome,
        meta: {
          title: "火眼 - 综合定位服务| IP服务| IP高精度定位",
          content: {
            keywords: "IP定位,地理位置,定位服务,经纬度数据",
            description: "ADmobile综合定位服务针对精细化地理位置需求场景，提供高精度的数据支持"
          }
        }
      }, {
        path: 'doc',
        name: "IpDoc",
        component: IpDoc,
      }, {
        path: '/user',
        name: "User",
        component: User,
      },
    ]
  },
  {
    path: '/',
    name: "Home",
    component: Home,
    meta: {
      title: "火眼 — 广告投放监测分析|移动广告营销情报中心",
      content: {
        keywords: "火眼,广告分析监测,广告监测系统,广告投放分析,头条广告投放监测,大数据分析,广告创意查询,广告文案搜索,竞品监控",
        description: "火眼是ADmobile旗下移动广告监测分析平台，拥有国内最大量级的广告图片监测分析系统，为广告主提供精准丰富的广告投放创意参考，帮助广告营销圈人士把握竞品动态和行业风向，全面洞悉广告圈生态，为投放决策提供数据支持。"
      }
    }
  },

  {
    path: '/',
    component: Auth,
    children: [{
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: "火眼 — 广告投放监测分析|移动广告营销情报中心",
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        title: "火眼 — 广告投放监测分析|移动广告营销情报中心",
      }
    },
    {
      path: '/forgetpassword',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: {
        title: "火眼 — 广告投放监测分析|移动广告营销情报中心",
      }
    }, {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title: "火眼 — 广告投放监测分析|移动广告营销情报中心",
      }
    }]
  },
  {
    path: '/',
    component: Base,
    children: [

      {
        path: '/search',
        name: "SearchResult",
        component: SearchResult,
      },
      {
        path: '/ad-material',
        name: "AdMaterial",
        component: AdMaterial,
        meta: {
          title: "火眼 — 广告素材分析|广告创意查询|头条广告监测",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/ad-detail',
        name: "AdMaterialDetail",
        component: AdMaterialDetail,
        meta: {
          title: "火眼 — 广告素材分析|广告创意查询|头条广告监测",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/landingpage',
        name: "Landingpage",
        component: Landingpage,
        meta: {
          title: "",
          content: {
            keywords: "",
            description: ""
          }
        }
      },
      {
        path: '/adideas',
        name: "AdIdeas",
        component: AdIdeas,
        meta: {
          title: "火眼 — 爆款文案|热门文案推荐|广告创意检索",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/adideas-detail',
        name: "AdIdeasDetail",
        component: AdIdeasDetail,
        meta: {
          title: "火眼 — 爆款文案|热门文案推荐|广告创意检索",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/industry',
        name: "Industry",
        component: Industry,
        meta: {
          title: "火眼 — 行业分析|广告投放趋势监测",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/admaster',
        name: "Admaster",
        component: Admaster,
        meta: {
          title: "火眼 — 广告主榜单|竞品分析|广告主投放趋势监测",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
      {
        path: '/admaster-detail',
        name: "AdmasterDetail",
        component: AdmasterDetail,
        meta: {
          title: "火眼 — 广告主榜单|竞品分析|广告主投放趋势监测",
          content: {
            keywords: "广告素材监测,广告素材分析,数据分析,情报获取,广告优化服务,广告创意,素材搜索,素材优化,竞品分析,广告分析,头条广告",
            description: "火眼广告素材分析平台，实时追踪移动广告情报，监测最新广告创意和行业广告投放趋势，为广告行业从业人士提供多维度的广告情报信息"
          }
        }
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function (to, from, next) {

  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    let keywords = document.querySelector('meta[name="keywords"]')
    if (keywords) {
      keywords.setAttribute('content', to.meta.content.keywords)
    }
    let description = document.querySelector('meta[name="keywords"]')
    if (description) {
      description.setAttribute('content', to.meta.content.description)
    }

    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (from.path != "/login" && to.path != "/register" && to.path != "/forgetpassword" && to.path != "/resetpassword" && to.path != "/") {
    if (!!to.query["session"]) {
      next()
      return
    }
    console.log("isLogin: ", localStorage.getItem("isLogin"))
    if (localStorage.getItem("isLogin") != "1") {
      if (to.path !== '/login') {
        return next('/login')
      }
    }
  }
  next()
  console.log("权限拦截结束。。。")
})

export default router
